import React, { createContext, useContext } from "react";

const FeedMediaPriorityContext = createContext(false);

/** First one or two feed tiles opt into eager, high-priority image delivery. */
export function FeedMediaPriorityProvider({
  priority,
  children,
}: {
  priority: boolean;
  children: React.ReactNode;
}) {
  return (
    <FeedMediaPriorityContext.Provider value={priority}>
      {children}
    </FeedMediaPriorityContext.Provider>
  );
}

export function useFeedMediaPriority(): boolean {
  return useContext(FeedMediaPriorityContext);
}
